import { TAccessibilitySettings } from '../models/accessibility.model';

export const accessibilitySettings: TAccessibilitySettings = {
    fontSize: {
        variableName: '--fsm',
        baseValue: 1,
        step: 0.05,
        maxValue: 1.2,
        minValue: 1,
    },
    lineHeight: {
        variableName: '--lhm',
        baseValue: 1,
        step: 0.1,
        maxValue: 1.5,
        minValue: 1,
    },
    letterSpacing: {
        variableName: '--lsm',
        baseValue: 1,
        step: 1,
        maxValue: 6,
        minValue: 1,
    },
    paragraphMargin: {
        variableName: '--psm',
        baseValue: 1,
        step: 0.5,
        maxValue: 4,
        minValue: 1,
    },
    wordSpacing: {
        variableName: '--wsm',
        baseValue: 1,
        step: 1,
        maxValue: 8,
        minValue: 1,
    },
    contrastMode: {
        variableName: '--cts',
        baseValue: 0,
        step: 1,
        maxValue: 1,
        minValue: 0,
        mode: 'turn',
    },
};
